import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { AiReceptionistDetail } from '../../models/AiReceptionist';

interface GetCompanyAiReceptionistDetailPayload {
  company_id: string;
  subscription_id: string;
}

export async function getCompanyAiReceptionistDetail(
  payload: GetCompanyAiReceptionistDetailPayload,
  auth: Authentication,
): Promise<AiReceptionistDetail> {
  try {
    if (!payload.company_id || !payload.subscription_id) {
      throw new GetCompanyAiReceptionistDetailFailure('company_id et subscription_id sont requis');
    }

    const response = await HttpClient.post('/company/ai-receptionist/detail', payload, auth.token);

    return response.data as AiReceptionistDetail;
  } catch (e) {
    console.error('getCompanyAiReceptionistDetail error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyAiReceptionistDetailFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyAiReceptionistDetailFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyAiReceptionistDetailFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
